import { Button, Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

const FavoritesHeader = ({ favoritesCount }: { favoritesCount: number }) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const dispatch = useAppDispatch();
  const { ACTIVITIES_URL } = useFullRoutes();

  return (
    <div className="flex gap-2x items-center justify-between w-full px-2x md:px-0">
      <div className="flex gap-x items-center">
        <Link
          to={ACTIVITIES_URL.ROOT}
          className="black md:hidden w-[32px] h-[32px] flex justify-center items-center"
        >
          <Icon
            name={locale === 'ar' ? 'chevron-right' : 'chevron-left'}
            size="24px"
            className="text-black "
          />
        </Link>
        <h1 className="text-title-2 !font-[400] text-black whitespace-nowrap">
          {t('savedPropertiesTitle')}
        </h1>
      </div>
      {favoritesCount ? (
        <div className="flex flex-wrap items-center gap-1.5x">
          <Button
            size="medium"
            onClick={() => {
              dispatch(openModal('deleteFavorite'));
            }}
            className="w-[48px] h-[48px] p-0  bg-gray_light_1 text-link-1 text-red_dark !rounded-full"
          >
            <Icon name="trash" />
          </Button>
          <Button
            size="medium"
            onClick={() => dispatch(openModal('shareProperties'))}
            className="w-[48px] h-[48px] !p-0 md:!px-2x md:!py-x md:w-max md:h-[40px] bg-gray_light_1 px-2x text-link-1 text-blue !rounded-full"
          >
            <Icon name="share" />
            <span className="hidden md:block">
              {t('savedPropertiesShareAll')}
            </span>
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default FavoritesHeader;
